import React from 'react';
import { Alert, Grid2, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TRIPADVISOR_URL_EXAMPLES = [
    'https://www.tripadvisor.com/Attraction_Review-g...-d...-Name.html',
    'https://www.tripadvisor.com/Hotel_Review-g...-d...-Name.html',
    'https://www.tripadvisor.com/Restaurant_Review-g...-d...-Name.html',
    'https://www.tripadvisor.com/AttractionProductReview-g...-d...-Name.html',
];

function TripAdvisorForm({ values, setFieldValue }) {
    const { t } = useTranslation();

    const url = values.settings?.tripadvisorUrl || '';
    const isProductUrl = url.includes('/AttractionProductReview-');

    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label={t('shows.columns.tripadvisorUrl')}
                    value={url}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            tripadvisorUrl: ev.target.value,
                        })
                    }
                    placeholder="https://www.tripadvisor.com/Attraction_Review-g...-d...-..."
                    helperText={
                        'Supported URL formats: Attraction_Review, Hotel_Review, Restaurant_Review, AttractionProductReview. ' +
                        'Example: ' +
                        TRIPADVISOR_URL_EXAMPLES[0]
                    }
                />
            </Grid2>
            {isProductUrl && (
                <Grid2 size={{ xs: 12 }}>
                    <Alert severity="info">
                        AttractionProductReview URLs refer to a bookable experience, not a location.
                        The system will search for the matching location automatically, but for best
                        results consider using a direct Attraction_Review, Hotel_Review, or
                        Restaurant_Review URL instead.
                    </Alert>
                </Grid2>
            )}
        </>
    );
}

export default TripAdvisorForm;
